import { Texture, TilingSprite, type Application, type Container } from "pixi.js";

/** Viewport-sized meadow, anchored to the camera. Owns only its small private texture. */
export class LandscapeBackdrop {
  readonly sprite: TilingSprite;

  constructor(material: HTMLImageElement) {
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = 512;
    const g = canvas.getContext("2d")!;
    g.drawImage(material, 0, 0, 512, 512);
    g.fillStyle = "#78836266";
    g.fillRect(0, 0, 512, 512);
    this.sprite = new TilingSprite({ texture: Texture.from(canvas), width: 1, height: 1 });
    this.sprite.eventMode = "none";
  }

  sync(app: Application, world: Container): void {
    this.sprite.width = app.screen.width;
    this.sprite.height = app.screen.height;
    this.sprite.tileScale.set((world.scale.x * 740) / 512);
    this.sprite.tilePosition.set(world.x - 370 * world.scale.x, world.y - 50 * world.scale.y);
  }

  destroy(): void {
    this.sprite.destroy({ texture: true, textureSource: true });
  }
}
